import { useState, useRef, useEffect } from "react";

import arrowDownDark from "@/assets/images/Arrow_drop_down.svg";
import arrowDownWhite from "@/assets/images/Arrow_drop_down_white_dark_mode.svg";

const BookmakerSelect = ({
  value,
  onChange,
  options,
  placeholder = "",
  className = "",
  triggerClassName = "",
  variant = "filled", // "filled" | "outline"
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => String(o.value) === String(value));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div
      className={`kbv-bookmaker-select-wrapper relative inline-block flex-shrink-0 ${className}`}
      ref={ref}
    >
      <div
        className={`kbv-bookmaker-select-trigger flex items-center gap-1.5 w-full min-w-0 text-sm rounded cursor-pointer select-none ${
          variant === "outline" ? "kbv-bookmaker-select-trigger--outline" : ""
        } ${triggerClassName}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="min-w-0 truncate">{selected ? selected.label : placeholder}</span>
        <img
          src={variant === "outline" ? arrowDownDark : arrowDownWhite}
          alt=""
          className={`kbv-bookmaker-select-arrow w-5 h-5 shrink-0 ${
            open ? "kbv-bookmaker-select-arrow--open" : ""
          }`}
        />
      </div>
      {open && (
        <ul className="kbv-bookmaker-select-list absolute left-0 top-full mt-1 min-w-full max-h-[200px] overflow-y-auto rounded z-[999] list-none m-0 p-0">
          {options.map((item) => (
            <li
              key={item.value}
              className={`kbv-bookmaker-select-item px-[10px] py-[7px] text-[13px] cursor-pointer whitespace-nowrap transition-colors ${
                String(item.value) === String(value)
                  ? "kbv-bookmaker-select-item--active"
                  : ""
              }`}
              onClick={() => handleSelect(item.value)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BookmakerSelect;

